import React from 'react';
import {Description as DescriptionIcon,} from '@mui/icons-material';
import {TaskWithImages} from '../hooks/useTaskDetail';
import {ResizableTextArea} from './ResizableTextArea';

interface TaskDescriptionProps {
    task: TaskWithImages | null;
    editMode: boolean;
    editingField: string | null;
    editValues: { [key: string]: any };
    getCurrentValue: (field: string) => any;
    setEditingField: (field: string | null) => void;
    handleEditValueChange: (field: string, value: any) => void;
    handleDescriptionSave: () => void;
}

export const TaskDescription: React.FC<TaskDescriptionProps> = ({
                                                                    task,
                                                                    editMode,
                                                                    editingField,
                                                                    editValues,
                                                                    getCurrentValue,
                                                                    setEditingField,
                                                                    handleEditValueChange,
                                                                    handleDescriptionSave,
                                                                }) => {
    return (
        <ResizableTextArea
            title="Beschreibung"
            icon={<DescriptionIcon color='primary'/>}
            value={getCurrentValue('description')}
            onChange={(value) => handleEditValueChange('description', value)}
            placeholder='Beschreibung der Aufgabe...'
            disabled={!editMode}
            minHeight={120}
            maxHeight={400}
            initialRows={4}
        />
    );
};
